import ScoreIndividual from "./ScoreIndividual";
export default ScoreIndividual;
